var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "snapshotModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.snapshot_notification"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("img", {
              attrs: {
                src: require("@/assets/img/brand/dt-logo-white-text.svg"),
                width: "200",
              },
            }),
          ]),
        ],
        1
      ),
      _c("hr"),
      _c("p", [
        _vm._v(
          "\n    This version of Dependency-Track is a snapshot release that is dynamically\n    generated from continuous integration or from manually compiling from a\n    branch. It is likely beta-quality software and has not undergone extensive\n    testing. It may contain defects and incomplete features and functionality.\n  "
        ),
      ]),
      _c("p", [
        _vm._v(
          "\n    Links to production-quality releases can be found at\n    "
        ),
        _c("a", { attrs: { href: "https://dependencytrack.org/" } }, [
          _vm._v("https://dependencytrack.org/"),
        ]),
      ]),
      _c("p", [
        _vm._v(
          "\n    Please consider contributing feedback and pull requests to help improve\n    the project. All contributions are appreciated. Visit Dependency-Track on\n    "
        ),
        _c("a", { attrs: { href: "https://github.com/DependencyTrack" } }, [
          _vm._v("GitHub"),
        ]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-github",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
      _c("p", [
        _c("strong", [
          _vm._v("Do not use snapshot releases on production data."),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }